// filepath: resources/js/redux/services/quiz_student_answers.jsx
import { createApi } from '@reduxjs/toolkit/query/react';
import { urls } from '../../utils/helpers/ApiClient.jsx';
import axiosFetchBase from '../axiosFetchBase';

export const quizStudentAnswersApi = createApi({
  reducerPath: 'quizStudentAnswersApi',
  keepUnusedDataFor: 0,
  baseQuery: axiosFetchBase,
  endpoints: (builder) => ({
    getStudentAnswers: builder.query({
      query(params) {
        return {
          url: urls.quizStudentAnswers,
          params,
        };
      },
    }),
    getAggregatedStudentQuizCorrectAnswers: builder.query({
      query(params) {
        return {
          url: urls.quizStudentAnswersAggregated,
          params,
        };
      },
    }),
    saveStudentAnswer: builder.mutation({
      query(body) {
        return {
          url: urls.quizStudentAnswers,
          method: 'POST',
          data: body,
          // Suppress global 422 toast; component will handle inline alert
          suppress422Toast: true,
        };
      },
    }),
  }),
});

export const {
  useGetStudentAnswersQuery,
  useGetAggregatedStudentQuizCorrectAnswersQuery,
  useSaveStudentAnswerMutation,
} = quizStudentAnswersApi;
